import { MEDIA_QUERY_FRAGMENT } from './media-gql';

export const TEXT_BRANDING_QUERY = `
    id
    title
    fontFamily
    fontSize
    aspectRatio
    fillColor {
      cssRgb
      red
      green
      blue
      alpha
      hex
    }
    backgroundColor {
      cssRgb
      red
      green
      blue
      alpha
      hex
    }
    backgroundTransparency
    backgroundAlignThreshold
    backgroundBorderRadius
    fontWeight
    uppercase
    italic
    xAlignment
    shadowColor {
      cssRgb
      red
      green
      blue
      alpha
      hex
    }
    shadowBlur
    shadowXOffset
    shadowYOffset
`;

export const BASIC_TEXT_BRANDING_QUERY = `{
  ${TEXT_BRANDING_QUERY}
  enterAnimation
  enterAnimationLength
  exitAnimation
  exitAnimationLength
  xPos
  yPos
  length
}`;

export const KARAOKE_TEXT_BRANDING_QUERY = `{
  ${TEXT_BRANDING_QUERY}
  xPos
  yPos
  strokeColor {
    cssRgb
    red
    green
    blue
    alpha
    hex
  }
  strokeWidth
  animation
  instagramLines
  hideComma
  hidePeriod
  hideFillers
  transcriptEffect
  transcriptSplit
  transcriptPlacement
  transcriptMaximumLength
  lineBreakStyle
  transcriptColor {
    cssRgb
    red
    green
    blue
    alpha
    hex
  }
  isGlobalPreset
  presetId
  previewText
}`;

export const GLOBAL_KARAOKE_PRESETS_QUERY = `query getGlobalKaraokePresets {
  allKaraokeTextBrandings(
    filter: {
      isGlobalPreset: { eq: true }
    }
    first: 100
  ) ${KARAOKE_TEXT_BRANDING_QUERY}
}`;

/**
 * PLAT-11416 — the caption templates' `language` values, fetched separately
 * from `KARAOKE_TEXT_BRANDING_QUERY` on purpose: Dato GraphQL hard-errors on
 * unknown fields, and environments where the PLAT-11411 migration hasn't run
 * yet don't have `language`. Keeping it out of the main fragment means only
 * this query fails there (caught and degraded to "no curated variants"),
 * instead of every story/album load. Fold into the main fragment only once
 * the migration is verified in every environment.
 */
export const KARAOKE_TEMPLATE_LANGUAGES_QUERY = `query getKaraokeTemplateLanguages($ids: [ItemId!]) {
  allKaraokeTextBrandings(filter: { id: { in: $ids } }, first: 500) {
    id
    language
  }
}`;

export const SHOWCASE_BRANDING_QUERY = `{
  id
  title
  primaryColors
  secondaryColors
  brandFonts
  customFonts
  fontFamilies
  fontStyles
  customFontFiles {
    id
    title
    url
  }
  designElements ${MEDIA_QUERY_FRAGMENT}
  brandVoice
  avoidWords
  organizationWebsite
  externalLinks
  customVocabulary
  goals {
    id
    label
    prePrompt
    finalPrompt
  }
  audiences {
    id
    label
    prePrompt
    finalPrompt
  }
}`;
